var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",class:_vm.ignoreStyle ? 'a-text' :`a-text a-text--${_vm.tag}${_vm.as ? `-${_vm.as}` : ''}`,attrs:{"for":_vm.getForProp}},'component',{..._vm.$attrs},false),[_vm._v(_vm._s(_vm.content)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }